<template>
  <div
    class="module module-logo-box padding_small_tb"
    v-observe-visibility="visibilityChanged"
    :class="[{ 'show-up': isVisible }, baseAnimation]"
  >
    <ModuleContainer class="logo-box-items">
      <boxWrapper
        v-for="(box, i) in data.box"
        :key="i"
        class="box-container"
        :class="[
          {
            'show-as-logo': box.show_as_logo,
            'show-as-image': !box.show_as_logo
          },
          'bg-' + box.theme,
          'items-' + data.box.length
        ]"
        :backgroundColor="box.theme === 'accent' ? box.accent_color : ''"
        :hoverColor="hoverColor(box)"
        :textColor="textColor(box)"
      >
        <WpImage
          v-if="box.logo_image && box.show_as_logo"
          :data="box.logo_image"
          size="medium"
          class="logo-image"
        />
        <WpImage
          v-if="box.logo_image && !box.show_as_logo"
          :data="box.logo_image"
          size="extra_large"
          class="normal-image"
        />
        <div class="content-wrapper">
          <DynamicHtml :html="box.content"></DynamicHtml>
          <LinksLine v-if="box.links" :data="box.links" />
        </div>
      </boxWrapper>
    </ModuleContainer>
  </div>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import LinksLine from "@/components/blocks/LinksLine";

import styled from "vue-styled-components";

const wrapperProps = {
  backgroundColor: String,
  textColor: String,
  hoverColor: String
};
const boxWrapper = styled("div", wrapperProps)`
  ${props =>
    props.backgroundColor && props.backgroundColor !== ""
      ? "background-color: " + props.backgroundColor
      : ""};
  ${props =>
    props.textColor && props.textColor !== ""
      ? "color: " + props.textColor
      : ""};
  ${props =>
    props.textColor && props.textColor !== ""
      ? "svg g{ fill: " + props.textColor + "}"
      : ""};
  a:hover {
    ${props =>
      props.hoverColor && props.hoverColor !== ""
        ? "color: " + props.hoverColor + "!important;"
        : ""};
    ${props =>
      props.hoverColor && props.hoverColor !== ""
        ? "~ .icon svg g {fill: " + props.hoverColor + "!important;}"
        : ""};
  }
`;

export default {
  name: "logo-box",
  props: ["data"],
  methods: {
    hoverColor(box) {
      let color = "";
      if (box && box.theme === "accent") {
        const pageThemes = WPVUE.options.avaible_colors;
        if (box.accent_color) {
          let theme = pageThemes.filter(
            thm => thm.select_color == box.accent_color
          );
          if (theme && theme[0] && theme[0].text_color === "light") {
            color = "#2A2E34";
          } else {
            color = "#fff";
          }
        }
      }
      return color;
    },
    textColor(box) {
      let color = "";
      if (box && box.theme === "accent") {
        const pageThemes = WPVUE.options.avaible_colors;
        if (box.accent_color) {
          let theme = pageThemes.filter(
            thm => thm.select_color == box.accent_color
          );
          if (theme && theme[0] && theme[0].text_color === "light") {
            color = "#fff";
          } else {
            color = "#2A2E34";
          }
        }
      }
      return color;
    }
  },
  components: {
    WpImage,
    LinksLine,
    boxWrapper
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.module-logo-box {
  .html-content {
    white-space: pre-line;
  }
  .logo-box-items {
    display: flex;
    flex-wrap: nowrap;
    @include mquery(767px) {
      flex-direction: column;
      padding: 0;
    }
    .content-wrapper {
      padding-bottom: 50px;
      .html-content {
        max-width: 800px;
        width: 100%;
        margin: 0 auto;
        padding: 20px 50px 0;
      }
      .links-line {
        padding-top: 20px;
      }
    }
    .image-hold {
      margin: 0;
      width: 100%;
      img {
        width: 100%;
        //max-height: 34px;
      }
      .picture_demension--16x9 {
        padding-bottom: inherit;
      }
    }
    .box-container {
      max-width: 100%;
      width: 100%;
      text-align: center;
      //padding: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &.show-as-image {
        align-self: end;
      }
      &.show-as-logo {
        padding-top: 50px;
      }
      .logo-image {
        img {
          max-height: 34px;
        }
      }
      .normal-image {
      }
      &.items-2 {
        max-width: 50%;
        @include mquery(767px) {
          max-width: 100%;
        }
      }
    }
    .items-2 {
      &:nth-child(odd) {
        margin-right: 5px;
        @include mquery(767px) {
          margin: 0;
        }
      }
      &:nth-child(even) {
        margin-left: 5px;
        @include mquery(767px) {
          margin: 0;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
